import { render, staticRenderFns } from "./nationalSubsidiesType.vue?vue&type=template&id=48ae7bc1&scoped=true&"
import script from "./nationalSubsidiesType.vue?vue&type=script&lang=js&"
export * from "./nationalSubsidiesType.vue?vue&type=script&lang=js&"
import style0 from "./nationalSubsidiesType.vue?vue&type=style&index=0&id=48ae7bc1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae7bc1",
  null
  
)

export default component.exports